import React from 'react';
import './StatCard.css';

const StatCard = ({ title, value, icon, color, subtitle }) => {
  return (
    <div className={`stat-card stat-card-${color}`}>
      <div className="stat-card-icon">
        {icon}
      </div>
      <div className="stat-card-content">
        <h3 className="stat-card-title">{title}</h3>
        <p className="stat-card-value">{value}</p>
        {subtitle && <small className="stat-card-subtitle">{subtitle}</small>}
      </div>
    </div>
  );
};

export default StatCard;
